import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

export function TableSkeleton() {
  return (
    <Table aria-busy="true" aria-label="Loading variables" className="table-fixed">
      <TableHeader>
        <TableRow className="hover:bg-transparent">
          {[30, 12, 12, 8, 12, 14, 12].map((w, i) => (
            <TableHead key={i} style={{ width: `${w}%` }}>
              <Skeleton className="h-3 w-14" />
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {[0, 1, 2, 3, 4].map((i) => (
          <TableRow key={i} className="hover:bg-transparent">
            {[36, 16, 14, 8, 16, 24, 20].map((w, j) => (
              <TableCell key={j} className="py-3">
                <Skeleton className="h-3.5" style={{ width: `${w * 3}px` }} />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export function CardsSkeleton() {
  return (
    <div className="flex flex-col gap-3 p-4" aria-busy="true">
      {[0, 1, 2].map((i) => (
        <Card key={i} className="gap-3 p-4 shadow-none">
          <Skeleton className="h-4 w-48" />
          <div className="flex gap-2">
            <Skeleton className="h-5 w-16" />
            <Skeleton className="h-5 w-14" />
          </div>
          <Skeleton className="h-3 w-full" />
        </Card>
      ))}
    </div>
  );
}
